import logo from "../../../theme/img/logo/logo2020-500.png";
import MyAccountButtonContainer from "../../../../shared/my_account_button/containers/MyAccountButtonContainer";
import Navigation from "../../account/components/Navigation";
import { isEmpty } from "lodash";
import { getUser } from "../../../data/account/selectors/user";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {PageLoader} from "../../shared/components/PageLoader";
import { PhoneIcon, EnvelopeIcon } from "@heroicons/react/24/outline";
import * as customerTypes from "../../../data/booking/constants/customer_types";
import { generate } from "../../../routing/routes";
import { Link } from "react-router-dom";
import { getIsSmallDesktop } from "../../shared/components/Responsive";
import cx from 'classnames';
import AdminForm from "../../account/components/AdminForm";

const App = ({ loading, page, children }) => {
    const isSmallDesktop = getIsSmallDesktop();
    const { t } = useTranslation();
    const user = useSelector((state) => getUser(state));
    const { data } = useSelector(state => state.account.userSession);

    return (
        <>
            {loading ? (
                <PageLoader />
            ) : (
                <div
                    className={
                        "container relative mx-auto min-h-screen px-4 py-8 sm:px-6 lg:px-8"
                    }
                >
                    <div className={"flex items-start justify-between"}>
                        <div>
                            <a href={generate("homepage")}>
                                <img src={logo} alt="logo" className={"w-24 sm:w-32"} />
                            </a>
                            {/* onClick={()=>{window.location.replace("../../")}} */}
                        </div>
                        <div className="hidden flex-1 items-center justify-end gap-x-6 lg:flex">
                            <span className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900">
                                {t("account_button.hello")} {user.contact.firstName}
                            </span>
                            <div className="mx-3 hidden h-5 w-px bg-slate-900/10 sm:block"></div>
                            <a
                                href="/security/sign-out"
                                className="rounded-md bg-orange-600 py-2 px-3 text-sm font-semibold text-white shadow-sm hover:bg-orange-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-orange-600"
                            >
                                {t("account_button.sign_out")}
                            </a>
                        </div>
                        <div className={"block lg:hidden"}>
                            <MyAccountButtonContainer />
                        </div>
                    </div>
                    <div className="mx-auto mt-16 flex w-full">
                        <div className={cx("hidden w-2/12 lg:block", {
                            "!w-1/5" : isSmallDesktop
                        })}>
                            <Navigation currentPage={page} />
                            {user.admin && <AdminForm />}
                            {data && customerTypes.BUSINESS === data.type && (
                                <div className="mt-20 p-3 flex flex-col gap-2 bg-gray-100 w-full rounded-md text-gray-600 shadow-lg border">
                                    <p className="text-lg font-semibold">{t("account_button.uppercase_contact_us")} :</p>
                                    <div className="text-sm flex justify-start">
                                        <PhoneIcon className="h-5 w-5 mr-1" aria-hidden="true"/>
                                        <p>04 71 04 20 72*</p>
                                    </div>
                                    <div className="text-sm inline-flex justify-start">
                                        <EnvelopeIcon className="h-5 w-5 mr-1" aria-hidden="true"/>
                                        <p className="break-words break-all">contact@lamallepostale.com</p>
                                    </div>
                                    <p className="text-xs mt-1 mb-3">* {t("account_button.reserved_line")}</p>
                                </div>
                            )}

                        </div>
                        <div className={cx("w-full lg:w-10/12", {
                            "!w-4/5" : isSmallDesktop
                        })}>
                            <div className="mx-auto lg:pl-16">
                                {children}
                                {/* divider */}
                                <hr
                                    className={
                                        "mx-auto mt-24 mb-12 w-[80%] border-gray-300"
                                    }
                                />
                            </div>
                            
                            {data && customerTypes.BUSINESS === data.type && (
                                <div className="lg:hidden flex flex-col items-center text-gray-800">
                                    <p className="text-lg font-semibold mb-2">{t("account_button.uppercase_contact_us")} :</p>
                                    <div className="text-sm flex justify-start">
                                        <PhoneIcon className="h-5 w-5 mr-1" aria-hidden="true"/>
                                        <p>04 71 04 20 72 *</p>
                                    </div>
                                    <p className="text-xs mt-1 mb-3">* {t("account_button.reserved_line")}</p>
                                    <div className="text-sm inline-flex justify-start">
                                        <EnvelopeIcon className="h-5 w-5 mr-1" aria-hidden="true"/>
                                        <p className="break-words break-all">contact@lamallepostale.com</p>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            )}
        </>
    );
};
export default App;
